import { render, staticRenderFns } from "./ExamTermModal.vue?vue&type=template&id=56d34a50&"
import script from "./ExamTermModal.vue?vue&type=script&lang=js&"
export * from "./ExamTermModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports